module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    on: {
      "close": function($event) {
        return _vm.$emit('fechar')
      }
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmar.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Alterar NUP")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-grande"
  }), _vm._v(" "), (_vm.projetoExigeNumeroDoProcesso) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "numeroDoProcesso"
    }
  }, [_vm._v("Processo NUP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.novoNumeroDoProcesso),
      expression: "novoNumeroDoProcesso"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99/999.999/9999'),
      expression: "'99/999.999/9999'"
    }],
    attrs: {
      "type": "text",
      "name": "numeroDoProcesso",
      "id": "numeroDoProcesso",
      "placeholder": "XX/XXX.XXX/XXXX",
      "required": ""
    },
    domProps: {
      "value": (_vm.novoNumeroDoProcesso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.novoNumeroDoProcesso = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-superior-grande u-margem-inferior-media"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_contorno botao_medio botao_cor-cinza u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('fechar')
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.carregando
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.novoNumeroDoProcesso
    }
  }, [_vm._v("\n        Salvar\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2eab0baa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eab0baa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/ModalAlterarNup.vue
// module id = 1106
// module chunks = 1